import { useEffect } from 'react';
import { loadOverlays, reportOverlayFailure, useOverlays } from '../../components/DeferredOverlay';
import { closeHelp, useHelp } from './open';

/**
 * The help panel's place in the shell — mounted once, beside `UniversalSearch`, so it outlives
 * every route change. Following a link in a guide navigates the page underneath it; the panel
 * stays open at the same guide.
 *
 * What is eager is this file, the store and the triggers. The panel's frame is in the shell's
 * overlays chunk (it needs Radix Dialog, which is there already) and the guides themselves are a
 * lazy chunk of their own — see `HelpDrawer`.
 */
export function Help() {
  const { open } = useHelp();
  const overlays = useOverlays();

  // Opened before the overlays chunk has landed: ask for it now. If it cannot arrive, close again
  // with a notice rather than staying "open" with nothing on screen — the arrangement search uses.
  useEffect(() => {
    if (!open || overlays) return;
    loadOverlays().catch(() => {
      closeHelp();
      reportOverlayFailure('Could not open help');
    });
  }, [open, overlays]);

  return overlays ? <overlays.HelpDrawer /> : null;
}
